// Remove old theme swatch conflict
$(document).off("change", ".swatch :radio");

// Swatch click handler
$(document).on("click", ".swatch-element", function () {
    var $this = $(this);
    var form = $this.closest("form");

    var value = $this.data("value");
    var index = parseInt($this.closest(".swatch").attr("data-option-index"));

    var select = form.find(".single-option-selector").eq(index);

    // Update Shopify selector
    select.val(value).trigger("change");

    // UI active state
    $this.closest(".swatch").find(".swatch-element").removeClass("active");
    $this.addClass("active");
});